// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.max_limit {
    width: 100%;
    height: 100%;
    padding: 20px;
    position: relative;
    display: grid;
    grid-template-columns: 50% 50%;
}
@media (max-width: 1100px) {
    .max_limit {
        grid-template-columns: 1fr;
    }
    .max_limit_right {
        max-width: 20vw;
        transform: translateY(-50px);
    }
}
.max_limit_left {
    width: 100%;
    height: 100%;
}
.max_limit_left >h3 {
    margin-bottom: 0;
    white-space: nowrap;
}
.max_limit_right {
    position: relative;
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
@media (max-width: 700px) {
    .max_limit_right {
        display: block;
        min-height: 250px;
    }
}
@media (max-width: 450px) {
    .max_limit_right {
        margin-left: 0;
    }
}
.doughnut_text_box {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (max-width: 700px) {
    .doughnut_text_box {
        width: 200px;
        transform: translateY(-15px);
    }
}
.doughnut_wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
}
@media (max-width: 700px) {
    .doughnut_wrapper {
        height: 250px;
        width: 200px;
    }
}
.doughnut_text {
    width: 105px;
    height: 105px;
    border-radius: 50%;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 1px 30px rgba(53,70,171,0.14);
    text-align: center;
    font-size: 10px;
    font-weight: 600;
    color: #767493;
}
.doughnut_number {
    font-size: 18px;
    color: #181143;
    font-weight: 700;
}
.bottom_rule {
    margin-left: 3px;
    border: 0px;
    border-bottom: 0.5px solid #dbd7d7;
    width: 94px;
}
.max_limit_count {
    margin-top: -7px;
    font-size: 22px;
    font-weight: 700;
}
.max_limit_nav_container {
    position: absolute;
    left: 20px;
    bottom: 15px;
}
.max_limit_row {
    margin-bottom: 1.5px;
    height: 24px;
}
.max_limit_dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #FF6E42;
    margin-right: 7px;
}
.max_limit_row > span {
    font-size: 12px;
    padding-left: 7px;
    font-weight: 600;
}

.gray {
    background-color: #09CE8A;
}
.ocean {
    background-color: #CDE1EB;
}
`, "",{"version":3,"sources":["webpack://./src/Components/DashboardCharts/MaxLimitChart.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,eAAe;QACf,4BAA4B;IAChC;AACJ;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI;QACI,YAAY;QACZ,4BAA4B;IAChC;AACJ;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;AACA;IACI;QACI,aAAa;QACb,YAAY;IAChB;AACJ;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IAEnB,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,kCAAkC;IAClC,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B","sourcesContent":[".max_limit {\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    position: relative;\n    display: grid;\n    grid-template-columns: 50% 50%;\n}\n@media (max-width: 1100px) {\n    .max_limit {\n        grid-template-columns: 1fr;\n    }\n    .max_limit_right {\n        max-width: 20vw;\n        transform: translateY(-50px);\n    }\n}\n.max_limit_left {\n    width: 100%;\n    height: 100%;\n}\n.max_limit_left >h3 {\n    margin-bottom: 0;\n    white-space: nowrap;\n}\n.max_limit_right {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n@media (max-width: 700px) {\n    .max_limit_right {\n        display: block;\n        min-height: 250px;\n    }\n}\n@media (max-width: 450px) {\n    .max_limit_right {\n        margin-left: 0;\n    }\n}\n.doughnut_text_box {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n@media (max-width: 700px) {\n    .doughnut_text_box {\n        width: 200px;\n        transform: translateY(-15px);\n    }\n}\n.doughnut_wrapper {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    z-index: 1;\n}\n@media (max-width: 700px) {\n    .doughnut_wrapper {\n        height: 250px;\n        width: 200px;\n    }\n}\n.doughnut_text {\n    width: 105px;\n    height: 105px;\n    border-radius: 50%;\n    background-color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    -webkit-box-shadow: 0px 1px 30px rgba(53,70,171,0.14);\n    box-shadow: 0px 1px 30px rgba(53,70,171,0.14);\n    text-align: center;\n    font-size: 10px;\n    font-weight: 600;\n    color: #767493;\n}\n.doughnut_number {\n    font-size: 18px;\n    color: #181143;\n    font-weight: 700;\n}\n.bottom_rule {\n    margin-left: 3px;\n    border: 0px;\n    border-bottom: 0.5px solid #dbd7d7;\n    width: 94px;\n}\n.max_limit_count {\n    margin-top: -7px;\n    font-size: 22px;\n    font-weight: 700;\n}\n.max_limit_nav_container {\n    position: absolute;\n    left: 20px;\n    bottom: 15px;\n}\n.max_limit_row {\n    margin-bottom: 1.5px;\n    height: 24px;\n}\n.max_limit_dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: #FF6E42;\n    margin-right: 7px;\n}\n.max_limit_row > span {\n    font-size: 12px;\n    padding-left: 7px;\n    font-weight: 600;\n}\n\n.gray {\n    background-color: #09CE8A;\n}\n.ocean {\n    background-color: #CDE1EB;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
